import { Separator } from "@/components/ui/separator";
import { EmployeesTable } from "./employees-table";
import { NestedQuota } from "@revelate/types";
import type { KeyedMutator } from "swr";
import { EmployeeCombobox } from "./components/employee-combobox";

export default function EmployeesPage({
  quota,
  mutate,
}: {
  quota: NestedQuota;
  mutate: KeyedMutator<NestedQuota | null>;
}) {
  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex">
        <div>
          <h3 className="text-sm font-medium">Employees</h3>
          <p className="text-sm text-muted-foreground">
            Connect this goal to employees to start measuring performance.
          </p>
        </div>

        <div className="ml-auto flex items-center gap-2">
          <EmployeeCombobox quota={quota} mutate={mutate} />
        </div>
      </div>
      <Separator />
      <EmployeesTable quota={quota} mutate={mutate} />
    </div>
  );
}
